import { RequestService } from '../../../common/services/RequestService';
import { GET_SERVICE_TYPES } from '../constants';

export const getServiceTypes = payload => {
  return RequestService.get(GET_SERVICE_TYPES);
};
